import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import aside from './modules/aside'
import glpm from './modules/glpm'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    aside,
    glpm
  }
})

export default store